if (!customElements.get('frame-finder-progress-bar')) {
    class FrameFinderProgressBar extends HTMLElement {
        constructor() {
            super();
            this.progressChunk = this.querySelector('.progress-chunk');
        }

        connectedCallback() {
            subscribe(PUB_SUB_EVENTS.ffProgresBarUpdate, (progress) => {
                FrameFinderProgressBarUtils.updateProgressBar(this.progressChunk, progress.questionIndex, progress.isQuestionNext);
            });
        }
    }

    customElements.define('frame-finder-progress-bar', FrameFinderProgressBar);
}